"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/leads/v1/step.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.stepNameToJSON = exports.stepNameFromJSON = exports.StepName = void 0;
/* eslint-disable */
/** StepName represent the different step names */
exports.StepName = {
    STEP_NAME_UNSPECIFIED: "STEP_NAME_UNSPECIFIED",
    STEP_NAME_CREATE: "STEP_NAME_CREATE",
    STEP_NAME_DONATION_EMAIL_REGISTRATION: "STEP_NAME_DONATION_EMAIL_REGISTRATION",
    STEP_NAME_DONATION_REGION_SELECTOR: "STEP_NAME_DONATION_REGION_SELECTOR",
    STEP_NAME_DONATION_PROJECT_DETAILS: "STEP_NAME_DONATION_PROJECT_DETAILS",
    STEP_NAME_DONATION_SOCIAL_FOOTPRINT: "STEP_NAME_DONATION_SOCIAL_FOOTPRINT",
    STEP_NAME_DONATION_GOAL_SETTING: "STEP_NAME_DONATION_GOAL_SETTING",
    STEP_NAME_DONATION_CONTACT_DETAILS: "STEP_NAME_DONATION_CONTACT_DETAILS",
    STEP_NAME_LENDING_EMAIL_REGISTRATION: "STEP_NAME_LENDING_EMAIL_REGISTRATION",
    STEP_NAME_LENDING_REGION_SELECTOR: "STEP_NAME_LENDING_REGION_SELECTOR",
    STEP_NAME_LENDING_SECTOR: "STEP_NAME_LENDING_SECTOR",
    STEP_NAME_LENDING_DEVELOPMENT_STAGE: "STEP_NAME_LENDING_DEVELOPMENT_STAGE",
    STEP_NAME_LENDING_FUNDS_ALLOCATION: "STEP_NAME_LENDING_FUNDS_ALLOCATION",
    STEP_NAME_LENDING_FINANCING_PLAN: "STEP_NAME_LENDING_FINANCING_PLAN",
    STEP_NAME_LENDING_PROJECT_DETAILS: "STEP_NAME_LENDING_PROJECT_DETAILS",
    STEP_NAME_LENDING_COMPANY_DETAILS: "STEP_NAME_LENDING_COMPANY_DETAILS",
    STEP_NAME_LENDING_TURNOVER: "STEP_NAME_LENDING_TURNOVER",
    STEP_NAME_LENDING_CONTACT_DETAILS: "STEP_NAME_LENDING_CONTACT_DETAILS",
    STEP_NAME_LENDING_DOCUMENTS_UPLOAD: "STEP_NAME_LENDING_DOCUMENTS_UPLOAD",
    STEP_NAME_PSFP_INVESTOR_TYPE: "STEP_NAME_PSFP_INVESTOR_TYPE",
    STEP_NAME_PSFP_NATURAL_THRESHOLDS: "STEP_NAME_PSFP_NATURAL_THRESHOLDS",
    STEP_NAME_PSFP_LEGAL_THRESHOLDS: "STEP_NAME_PSFP_LEGAL_THRESHOLDS",
    STEP_NAME_PSFP_INVESTMENT_OBJECTIVES: "STEP_NAME_PSFP_INVESTMENT_OBJECTIVES",
    STEP_NAME_PSFP_INVESTMENT_EXPERIENCE: "STEP_NAME_PSFP_INVESTMENT_EXPERIENCE",
    STEP_NAME_PSFP_RISK_UNDERSTANDING: "STEP_NAME_PSFP_RISK_UNDERSTANDING",
    STEP_NAME_PSFP_NET_WEALTH_SIMULATION: "STEP_NAME_PSFP_NET_WEALTH_SIMULATION",
    STEP_NAME_END: "STEP_NAME_END",
    STEP_NAME_END_NOT_ENOUGH_TURNOVER: "STEP_NAME_END_NOT_ENOUGH_TURNOVER",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function stepNameFromJSON(object) {
    switch (object) {
        case 0:
        case "STEP_NAME_UNSPECIFIED":
            return exports.StepName.STEP_NAME_UNSPECIFIED;
        case 1:
        case "STEP_NAME_CREATE":
            return exports.StepName.STEP_NAME_CREATE;
        case 100:
        case "STEP_NAME_DONATION_EMAIL_REGISTRATION":
            return exports.StepName.STEP_NAME_DONATION_EMAIL_REGISTRATION;
        case 101:
        case "STEP_NAME_DONATION_REGION_SELECTOR":
            return exports.StepName.STEP_NAME_DONATION_REGION_SELECTOR;
        case 102:
        case "STEP_NAME_DONATION_PROJECT_DETAILS":
            return exports.StepName.STEP_NAME_DONATION_PROJECT_DETAILS;
        case 103:
        case "STEP_NAME_DONATION_SOCIAL_FOOTPRINT":
            return exports.StepName.STEP_NAME_DONATION_SOCIAL_FOOTPRINT;
        case 104:
        case "STEP_NAME_DONATION_GOAL_SETTING":
            return exports.StepName.STEP_NAME_DONATION_GOAL_SETTING;
        case 105:
        case "STEP_NAME_DONATION_CONTACT_DETAILS":
            return exports.StepName.STEP_NAME_DONATION_CONTACT_DETAILS;
        case 200:
        case "STEP_NAME_LENDING_EMAIL_REGISTRATION":
            return exports.StepName.STEP_NAME_LENDING_EMAIL_REGISTRATION;
        case 201:
        case "STEP_NAME_LENDING_REGION_SELECTOR":
            return exports.StepName.STEP_NAME_LENDING_REGION_SELECTOR;
        case 202:
        case "STEP_NAME_LENDING_SECTOR":
            return exports.StepName.STEP_NAME_LENDING_SECTOR;
        case 203:
        case "STEP_NAME_LENDING_DEVELOPMENT_STAGE":
            return exports.StepName.STEP_NAME_LENDING_DEVELOPMENT_STAGE;
        case 204:
        case "STEP_NAME_LENDING_FUNDS_ALLOCATION":
            return exports.StepName.STEP_NAME_LENDING_FUNDS_ALLOCATION;
        case 205:
        case "STEP_NAME_LENDING_FINANCING_PLAN":
            return exports.StepName.STEP_NAME_LENDING_FINANCING_PLAN;
        case 206:
        case "STEP_NAME_LENDING_PROJECT_DETAILS":
            return exports.StepName.STEP_NAME_LENDING_PROJECT_DETAILS;
        case 207:
        case "STEP_NAME_LENDING_COMPANY_DETAILS":
            return exports.StepName.STEP_NAME_LENDING_COMPANY_DETAILS;
        case 208:
        case "STEP_NAME_LENDING_TURNOVER":
            return exports.StepName.STEP_NAME_LENDING_TURNOVER;
        case 209:
        case "STEP_NAME_LENDING_CONTACT_DETAILS":
            return exports.StepName.STEP_NAME_LENDING_CONTACT_DETAILS;
        case 210:
        case "STEP_NAME_LENDING_DOCUMENTS_UPLOAD":
            return exports.StepName.STEP_NAME_LENDING_DOCUMENTS_UPLOAD;
        case 400:
        case "STEP_NAME_PSFP_INVESTOR_TYPE":
            return exports.StepName.STEP_NAME_PSFP_INVESTOR_TYPE;
        case 410:
        case "STEP_NAME_PSFP_NATURAL_THRESHOLDS":
            return exports.StepName.STEP_NAME_PSFP_NATURAL_THRESHOLDS;
        case 420:
        case "STEP_NAME_PSFP_LEGAL_THRESHOLDS":
            return exports.StepName.STEP_NAME_PSFP_LEGAL_THRESHOLDS;
        case 421:
        case "STEP_NAME_PSFP_INVESTMENT_OBJECTIVES":
            return exports.StepName.STEP_NAME_PSFP_INVESTMENT_OBJECTIVES;
        case 422:
        case "STEP_NAME_PSFP_INVESTMENT_EXPERIENCE":
            return exports.StepName.STEP_NAME_PSFP_INVESTMENT_EXPERIENCE;
        case 423:
        case "STEP_NAME_PSFP_RISK_UNDERSTANDING":
            return exports.StepName.STEP_NAME_PSFP_RISK_UNDERSTANDING;
        case 424:
        case "STEP_NAME_PSFP_NET_WEALTH_SIMULATION":
            return exports.StepName.STEP_NAME_PSFP_NET_WEALTH_SIMULATION;
        case 300:
        case "STEP_NAME_END":
            return exports.StepName.STEP_NAME_END;
        case 301:
        case "STEP_NAME_END_NOT_ENOUGH_TURNOVER":
            return exports.StepName.STEP_NAME_END_NOT_ENOUGH_TURNOVER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.StepName.UNRECOGNIZED;
    }
}
exports.stepNameFromJSON = stepNameFromJSON;
function stepNameToJSON(object) {
    switch (object) {
        case exports.StepName.STEP_NAME_UNSPECIFIED:
            return "STEP_NAME_UNSPECIFIED";
        case exports.StepName.STEP_NAME_CREATE:
            return "STEP_NAME_CREATE";
        case exports.StepName.STEP_NAME_DONATION_EMAIL_REGISTRATION:
            return "STEP_NAME_DONATION_EMAIL_REGISTRATION";
        case exports.StepName.STEP_NAME_DONATION_REGION_SELECTOR:
            return "STEP_NAME_DONATION_REGION_SELECTOR";
        case exports.StepName.STEP_NAME_DONATION_PROJECT_DETAILS:
            return "STEP_NAME_DONATION_PROJECT_DETAILS";
        case exports.StepName.STEP_NAME_DONATION_SOCIAL_FOOTPRINT:
            return "STEP_NAME_DONATION_SOCIAL_FOOTPRINT";
        case exports.StepName.STEP_NAME_DONATION_GOAL_SETTING:
            return "STEP_NAME_DONATION_GOAL_SETTING";
        case exports.StepName.STEP_NAME_DONATION_CONTACT_DETAILS:
            return "STEP_NAME_DONATION_CONTACT_DETAILS";
        case exports.StepName.STEP_NAME_LENDING_EMAIL_REGISTRATION:
            return "STEP_NAME_LENDING_EMAIL_REGISTRATION";
        case exports.StepName.STEP_NAME_LENDING_REGION_SELECTOR:
            return "STEP_NAME_LENDING_REGION_SELECTOR";
        case exports.StepName.STEP_NAME_LENDING_SECTOR:
            return "STEP_NAME_LENDING_SECTOR";
        case exports.StepName.STEP_NAME_LENDING_DEVELOPMENT_STAGE:
            return "STEP_NAME_LENDING_DEVELOPMENT_STAGE";
        case exports.StepName.STEP_NAME_LENDING_FUNDS_ALLOCATION:
            return "STEP_NAME_LENDING_FUNDS_ALLOCATION";
        case exports.StepName.STEP_NAME_LENDING_FINANCING_PLAN:
            return "STEP_NAME_LENDING_FINANCING_PLAN";
        case exports.StepName.STEP_NAME_LENDING_PROJECT_DETAILS:
            return "STEP_NAME_LENDING_PROJECT_DETAILS";
        case exports.StepName.STEP_NAME_LENDING_COMPANY_DETAILS:
            return "STEP_NAME_LENDING_COMPANY_DETAILS";
        case exports.StepName.STEP_NAME_LENDING_TURNOVER:
            return "STEP_NAME_LENDING_TURNOVER";
        case exports.StepName.STEP_NAME_LENDING_CONTACT_DETAILS:
            return "STEP_NAME_LENDING_CONTACT_DETAILS";
        case exports.StepName.STEP_NAME_LENDING_DOCUMENTS_UPLOAD:
            return "STEP_NAME_LENDING_DOCUMENTS_UPLOAD";
        case exports.StepName.STEP_NAME_PSFP_INVESTOR_TYPE:
            return "STEP_NAME_PSFP_INVESTOR_TYPE";
        case exports.StepName.STEP_NAME_PSFP_NATURAL_THRESHOLDS:
            return "STEP_NAME_PSFP_NATURAL_THRESHOLDS";
        case exports.StepName.STEP_NAME_PSFP_LEGAL_THRESHOLDS:
            return "STEP_NAME_PSFP_LEGAL_THRESHOLDS";
        case exports.StepName.STEP_NAME_PSFP_INVESTMENT_OBJECTIVES:
            return "STEP_NAME_PSFP_INVESTMENT_OBJECTIVES";
        case exports.StepName.STEP_NAME_PSFP_INVESTMENT_EXPERIENCE:
            return "STEP_NAME_PSFP_INVESTMENT_EXPERIENCE";
        case exports.StepName.STEP_NAME_PSFP_RISK_UNDERSTANDING:
            return "STEP_NAME_PSFP_RISK_UNDERSTANDING";
        case exports.StepName.STEP_NAME_PSFP_NET_WEALTH_SIMULATION:
            return "STEP_NAME_PSFP_NET_WEALTH_SIMULATION";
        case exports.StepName.STEP_NAME_END:
            return "STEP_NAME_END";
        case exports.StepName.STEP_NAME_END_NOT_ENOUGH_TURNOVER:
            return "STEP_NAME_END_NOT_ENOUGH_TURNOVER";
        case exports.StepName.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.stepNameToJSON = stepNameToJSON;
//# sourceMappingURL=step.js.map